import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import Footer from 'components/common/Footer';
import { ReactComponent as InvalidLinkIcon } from 'assets/documentRequestIcons/invalid-link.svg';
import { DOCUMENT_REQUEST_STATUSES } from 'stores/documentRequestStore';
import './styles.scss';

const InvalidLinkScreen = ({ status = null }) => {
  const i18n = useContext(i18nContext);
  const logoPath = process.env.REACT_APP_LOGO_PATH;

  // Determine which messages to show based on status
  const isCancelled = status === DOCUMENT_REQUEST_STATUSES.CANCELLED;
  const titleKey = isCancelled ? 'documentRequest.cancelled.title' : 'documentRequest.invalidLink.title';
  const descriptionKey = isCancelled
    ? 'documentRequest.cancelled.description'
    : 'documentRequest.invalidLink.description';

  return (
    <div className='document-request-container'>
      <div className='document-request-header'>
        <a href={process.env.REACT_APP_LINK_HOME_PAGE} className='logo'>
          <img src={logoPath} alt='Logo' className='icon-logo' />
        </a>
      </div>

      <div className='document-final-screen-content'>
        <div className='final-screen-card'>
          <div className='final-icon-container'>
            <InvalidLinkIcon className='final-screen-icon' />
          </div>

          <div className='final-screen-content'>
            <h1 className='final-screen-title'>{i18n.getMessage(titleKey)}</h1>

            <p className='final-screen-description'>{i18n.getMessage(descriptionKey)}</p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

InvalidLinkScreen.propTypes = {
  status: PropTypes.string
};

export default InvalidLinkScreen;
